module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "手动分配",
      "width": "800"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "modalForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 18
    }
  }, [_c('FormItem', [_c('label', [_c('h3', [_vm._v("您选择的名单共计" + _vm._s(_vm.formData.totalNum) + "个, 当前未分配客户数" + _vm._s(_vm.formData.remainder) + "个")])])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "选择课顾分组"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onTeamTypeChange
    },
    model: {
      value: (_vm.formData.teamType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "teamType", $$v)
      },
      expression: "formData.teamType"
    }
  }, _vm._l((_vm.formData.adviserGroupList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('ul', _vm._l((_vm.formData.adviserList), function(item) {
    return _c('li', [_c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('FormItem', {
      attrs: {
        "label": item.adviserName
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "名单数"
      },
      on: {
        "on-change": _vm.onCountChange
      },
      model: {
        value: (item.count),
        callback: function($$v) {
          _vm.$set(item, "count", $$v)
        },
        expression: "item.count"
      }
    })], 1)], 1)], 1)
  }), 0)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.insertLoading
    },
    on: {
      "click": _vm.confirmAssign
    }
  }, [_vm._v("确认分配")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f7720f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/ManualAssignModal.vue
// module id = 1717
// module chunks = 8